import { request } from "@umijs/max";

export const apiNotificationCount = () => request(`notification/count`);

export const apiNotificationRecentList = () => request(`notification/recent-list`);

export const apiMaskAsReadNotification = (id: string) => request(`notification/mark-as-read/${id}`, {
    method: 'POST'
});